var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-block"},[_c('div',{staticClass:"header-block__logo"},[_vm._v("MEBUKi Admin")]),_c('div',{staticClass:"header-block__administrator"},[_vm._v(_vm._s(_vm.administrator.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }